import React from 'react';
import { useEffect, useRef, useState } from 'react';
import * as API from 'utils/API/API';

const User = API.user();

export function TrustIframe({ onSuccess, onlyForNewUsers = false }) {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(500);
  const [iframeUrl, setIframeUrl] = useState(null);

  useEffect(() => {
    async function getUrl() {
      if (iframeUrl) {
        return;
      }

      try {
        const { widgetLink } = await User.getKycWidgetLink(onlyForNewUsers);
        setIframeUrl(widgetLink);
      } catch (error) {
        console.error(error);
      }
    }

    async function handleMessage(event) {
      let widgetEvent = event.data;

      if (widgetEvent.event === 'document.height') {
        setIframeHeight(widgetEvent.document.height);
      } else if (widgetEvent.event === 'document.loaded') {
        // document loaded
      } else if (widgetEvent.event === 'document.failed') {
        // The document failed to load
        console.error(`Document failed to load. Name of the event - ${widgetEvent.event}.`);
        console.error(`Error Message: "${widgetEvent.document.message}".`);
        console.error(`Error Code: "${widgetEvent.document.code}"`);
      } else if (widgetEvent.event === 'module.loaded') {
        // A module widgetEvent.module[0] has been loaded
      } else if (widgetEvent.event === 'module.successful') {
        if (widgetEvent.module[0] === 'trust') {
          await User.kycVerify();
          onSuccess?.();
        }
        // A module has submitted its data successfully
      } else if (widgetEvent.event === 'module.failed') {
        // A module failed to submitted it's data
        console.error(`${widgetEvent.module[0]} module failed.`);
      }
    }

    getUrl();
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [iframeUrl, onSuccess, onlyForNewUsers]);

  return (
    <iframe
      height={Math.min(iframeHeight, 500)}
      id="trolley-widget"
      ref={iframeRef}
      src={iframeUrl}
      style={{ border: 'none' }}
      title="Trolley Trust"
      width="100%"
    />
  );
}
